import React, { useEffect, useState } from "react";
import { EVENT } from "@/lib/data";

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ compact = false }) => {
  const target = new Date(EVENT.showTimeISO).getTime();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(target - now, 0);
  const past = diff === 0;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  if (past) {
    return (
      <div data-testid="hero-countdown-timer" className="glass rounded-full px-5 py-2.5 text-sm text-[#F3D068] inline-flex items-center gap-2">
        Early bird pricing has ended — regular pricing in effect
      </div>
    );
  }

  if (compact) {
    return (
      <div data-testid="hero-countdown-timer" className="glass rounded-full px-4 py-2 text-xs sm:text-sm text-[#F3D068] inline-flex items-center gap-2 whitespace-nowrap">
        <span className="w-1.5 h-1.5 rounded-full bg-[#F3D068] glow-pulse inline-block" />
        Early bird $129 ends in {d}d {pad(h)}h {pad(m)}m {pad(s)}s
      </div>
    );
  }

  const cells = [
    { v: d, l: "days" },
    { v: h, l: "hours" },
    { v: m, l: "min" },
    { v: s, l: "sec" },
  ];
  return (
    <div data-testid="hero-countdown-timer" className="flex items-center gap-3 sm:gap-4">
      {cells.map((c) => (
        <div key={c.l} className="glass rounded-2xl px-4 sm:px-5 py-3 text-center min-w-[70px] sm:min-w-[84px]">
          <div className="font-cinzel text-2xl sm:text-3xl text-[#F3D068] tabular-nums">
            {pad(c.v)}
          </div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#8A99B5] mt-1">{c.l}</div>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
